/**
 * Reads the string `value` from a Modus Web Components `inputChange` custom event.
 * Modus emits `detail.target.value` on the host (see project Modus integration notes).
 */
export function readModusInputChangeValue(event: Event): string {
  const detail = (event as CustomEvent).detail as unknown;
  if (detail && typeof detail === 'object') {
    if ('target' in detail) {
      const target = (detail as { target?: HTMLInputElement | null }).target;
      if (typeof target?.value === 'string') {
        return target.value;
      }
    }
    if ('value' in detail) {
      const value = (detail as { value?: unknown }).value;
      if (typeof value === 'string') {
        return value;
      }
    }
  }
  return '';
}

/**
 * Returns a handler suitable for `on:inputChange` on Modus inputs that updates a string signal or setter.
 */
export function createModusInputChangeHandler(
  setValue: (value: string) => void
): (e: Event) => void {
  return (e: Event) => {
    setValue(readModusInputChangeValue(e));
  };
}
